import { FC } from 'react';

import { useCurrentPricingPlan } from 'common/hooks/useCurrentPricingPlan';
import useFeatureFlagsSwitcher from 'common/hooks/useFeatureFlagsSwitcher';
import { getInsuranceSummaryUrl } from 'common/insurance';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import SunshineLoader from 'components/_core/SunshineLoader';
import SunshineModal, {
  SunshineModalProps,
} from 'components/_core/SunshineModal';
import Text from 'components/_core/Text';

import shieldRebrandedImg from './assets/Shield@2x.png';
import locales from './locales';

const CoverageSummaryModal: FC<Omit<SunshineModalProps, 'children'>> = (
  props,
) => {
  const { plan } = useCurrentPricingPlan();
  const { featureFlags } = useFeatureFlagsSwitcher();

  return (
    <SunshineModal {...props}>
      <SunshineModal.Header />
      <SunshineModal.Body>
        <SunshineModal.Body.Image src={shieldRebrandedImg} />
        <Heading marginBottom="space-16">{locales.title}</Heading>
        <Text marginBottom="space-20">{locales.description}</Text>

        {plan ? (
          <Button
            as="a"
            href={getInsuranceSummaryUrl(plan.providerPlanId, {
              enableNewInsurance: featureFlags.enableNewInsurance,
            })}
            icon="link"
            target="_blank"
            variant="inline-primary"
          >
            {locales.noticeCta}
          </Button>
        ) : (
          <SunshineLoader />
        )}
      </SunshineModal.Body>
    </SunshineModal>
  );
};

export default CoverageSummaryModal;
